import { useTranslation } from "react-i18next";

export default function NotFound() {
    const { t } = useTranslation();
    return (
        <div style={{ textAlign: "center", marginTop: 100 }}>
            <h1>404</h1>
            <p>{t("common.pageNotFound")}</p>
        </div>
    );
}
